module.exports = __webpack_public_path__ + "img/lange_crub_3.d63287c0.jpg";